import { inject, Injectable } from '@angular/core';
import { ZonasService } from './core/services/zonas.service';
import { PaquetesService } from './core/services/paquetes/paquetes.service';
import { IvasService } from './core/services/ivas.service';
import { TiposTurnoService } from './core/services/tipos/tiposTurno/tipos-turno.service';
import { catchError, forkJoin, of } from 'rxjs';
import { Resolve } from '@node_modules/@angular/router/router';
import { TiposAgrupacionesService } from './core/services/tipos/tiposAgrupaciones/tipos-agrupaciones.service';
import { TiposMenuService } from './core/services/tipos/tiposMenu/tipos-menu.service';
import { TarifasService } from './core/services/tarifas/tarifas.service';
import { PagosAdminService } from './core/services/pagos/pagosAdmin/pagos-admin-metodos.service';

@Injectable({
  providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any> {

  constructor(
    private zonasService: ZonasService,
    private paquetesService: PaquetesService,
    private ivasService: IvasService,
    private tiposTurnosService: TiposTurnoService,
    private tiposAgrupacionesService: TiposAgrupacionesService,
    private tiposMenusService: TiposMenuService,
    private tarifasService: TarifasService,
    private pagosAdminService: PagosAdminService
  ) {}

  resolve() {
    return forkJoin([
      // this.zonasService.getAll().pipe(catchError(() => of(null))),
      // this.paquetesService.getAll().pipe(catchError(() => of(null)))
      this.ivasService.getAll().pipe(catchError(() => of(null))),
      this.tiposTurnosService.getAll().pipe(catchError(() => of(null))),
      this.tiposAgrupacionesService.getAll().pipe(catchError(() => of(null))),
      this.tiposMenusService.getAll().pipe(catchError(() => of(null))),
      this.tarifasService.getAll().pipe(catchError(() => of(null))),
      this.pagosAdminService.getAll().pipe(catchError(() => of(null))),    
    ]);
  }
}
